export const environment = {

    production: `true`,
    
    urls: {
        planilhas: `https://planilhas.api.sigevs.pdsa-rs.com.br`,
        sigevs: `https://api.sigevs.pdsa-rs.com.br`,
        aves: ``, 
        geo: ``,
        notification: ``,
        
    },
    // Por enquanto manter esse keycloak // TODO: Alterar para um keycloak próprio
    keycloak: {
        url: `https://oauth.pdsa-rs.com.br/auth`,
        realm: `sigevs-prod`,
        clientId: `sigevs-web`,
        clientSecret: ``,
        logoutGov: `https://sso.staging.acesso.gov.br/logout`,
    },
    // Por enquanto manter esse servidor de assinatura // TODO: Alterar para um servidor de assinatura próprio
    signGov: {
        url: `https://assinador.review.pdsa-rs.com.br/assinatura`,
        clientId: `pdsarshom`,
        login: {
            url: `https://assinador.review.pdsa-rs.com.br/login`,
            clientId: `pdsa.oauth.pdsa-rs.com.br`,
        },
        certificado: `https://assinador.review.pdsa-rs.com.br/assinatura/certificadoPublico`,
        confiabilidade: `https://confiabilidades.staging.acesso.gov.br`,
    },
    gmapsKey: `AIzaSyAgx9pblLSLfk2qnG2Q-il8Imfbl3ZdgSk`
} 

  